import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "@/contexts/LanguageContext";

const EditorialMarquee = () => {
  const { t } = useLang();
  const chunks = t.marquee.split("·");

  return (
    <section
      data-testid="editorial-marquee"
      className="py-8 md:py-10 border-y border-white/10 bg-black"
    >
      <Marquee gradient={false} speed={40} pauseOnHover>
        {chunks.map((c, i) => (
          <span
            key={i}
            className="font-display text-4xl md:text-6xl lg:text-7xl tracking-tight uppercase stroke-text mx-8"
          >
            {c.trim()}
            {i < chunks.length - 1 && (
              <span className="mx-6 text-[var(--hk-red)]">·</span>
            )}
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
